import React from 'react';
// import { AiOutlineSafetyCertificate } from 'react-icons/ai';
import { BiWrench } from 'react-icons/bi';
import { BsHeadset, BsReceipt, BsTruck } from 'react-icons/bs';
import { FaBarcode } from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';

import { MdContactPhone } from 'react-icons/md';
import { Button, Card, CardImage, ContentCard, Icon, Title } from './styles';

const cards = [
  {
    image: 'static/card_solicitacao_abastecimento.png',
    icon: BsTruck,
    title: 'Solicitação de abastecimento',
    buttonText: 'Ver mais',
    to: '/pedido-abastecimento',
  },
  {
    image: 'static/card_2_via_boletos.png',
    icon: FaBarcode,
    title: '2ª via de boletos',
    buttonText: 'Ver mais',
    to: '/boletos',
  },
  {
    image: 'static/card_2_via_nota.png',
    icon: BsReceipt,
    title: '2ª via de notas fiscais',
    buttonText: 'Ver mais',
    to: '/notas',
  },
  {
    image: 'static/card_solicitacao_manutencao.png',
    icon: BiWrench,
    title: 'Solicitação de manutenção',
    buttonText: 'Ver mais',
    to: '/manutencao',
  },
  {
    image: 'static/card_consultor_comercial.jpg',
    icon: MdContactPhone,
    title: 'Atendimento Comercial',
    buttonText: 'Ver mais',
    to: '/atendimento-comercial',
  },
  {
    image: 'static/card_fale_conosco.png',
    icon: BsHeadset,
    title: 'Fale conosco',
    buttonText: 'Ver mais',
    to: '/fale-conosco',
  },
];

const CTOS = (): JSX.Element => {
  return (
    <ContentCard className="cards-intro">
      {cards?.map((card) => {
        const IconCard = card.icon;
        return (
          <Card key={card?.to}>
            <CardImage image={card?.image} />
            <Icon>
              <IconCard />
            </Icon>
            <Title>{card?.title}</Title>
            <Button to={card.to}>
              <span>{card?.buttonText}</span>
              <FiArrowRight />
            </Button>
          </Card>
        );
      })}
    </ContentCard>
  );
};

export default CTOS;
